var _path, _path2, _g, _g2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAdminInviteEmptystate = function SvgAdminInviteEmptystate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M62.726 62.618c-10.83 0-19.739 8.4-20.81 19.166-.118 1.199.87 2.178 2.076 2.178h37.47c1.205 0 2.193-.98 2.074-2.178-1.069-10.765-9.977-19.166-20.81-19.166Z",
    fill: "url(#admin-invite-emptystate_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M73.661 47.972c0 6.038-4.895 10.933-10.933 10.933S51.795 54.01 51.795 47.972s4.895-10.934 10.933-10.934 10.933 4.896 10.933 10.934Z",
    fill: "url(#admin-invite-emptystate_svg__b)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.757 73.157a21.249 21.249 0 0 0-7.203-7.437c2.574-4.774 7.553-8.011 13.273-8.011 7.637 0 13.954 5.77 14.99 13.273.165 1.193-.827 2.175-2.032 2.175H80.757Z",
    fill: "url(#admin-invite-emptystate_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.826 55.022a7.913 7.913 0 1 0 0-15.827 7.913 7.913 0 0 0 0 15.827Z",
    fill: "url(#admin-invite-emptystate_svg__d)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.696 73.158a21.251 21.251 0 0 1 7.202-7.437c-2.574-4.775-7.553-8.012-13.272-8.012-7.637 0-13.955 5.771-14.991 13.273-.164 1.194.829 2.176 2.033 2.176h19.028Z",
    fill: "url(#admin-invite-emptystate_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.626 55.022a7.913 7.913 0 1 1 0-15.826 7.913 7.913 0 0 1 0 15.826Z",
    fill: "url(#admin-invite-emptystate_svg__f)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "admin-invite-emptystate_svg__a",
    x1: 64.965,
    y1: 41.598,
    x2: 47.814,
    y2: 83.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "admin-invite-emptystate_svg__b",
    x1: 64.966,
    y1: 41.598,
    x2: 47.815,
    y2: 83.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "admin-invite-emptystate_svg__c",
    x1: 94.019,
    y1: 39.195,
    x2: 78.705,
    y2: 66.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "admin-invite-emptystate_svg__d",
    x1: 94.019,
    y1: 39.195,
    x2: 78.705,
    y2: 66.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "admin-invite-emptystate_svg__e",
    x1: 31.434,
    y1: 39.195,
    x2: 46.748,
    y2: 66.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "admin-invite-emptystate_svg__f",
    x1: 31.434,
    y1: 39.195,
    x2: 46.748,
    y2: 66.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.2
  })))));
};

export default SvgAdminInviteEmptystate;